var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 3,
    fill: "#377FFF",
    stroke: "#377FFF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9635 11.5364C6.76823 11.7317 6.45165 11.7317 6.25639 11.5364L4.02962 9.30968C3.73709 9.01715 3.26279 9.01715 2.97026 9.30968C2.67748 9.60247 2.67776 10.0772 2.9709 10.3697L5.90283 13.2946C6.2935 13.6843 6.92601 13.6839 7.3162 13.2937L15.0299 5.58001C15.3222 5.2877 15.3211 4.81343 15.0274 4.52251C14.7357 4.23354 14.2653 4.23465 13.9749 4.52501L6.9635 11.5364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.ee615ffba4a9210ace4a7430e671fd34.svg";
export { ForwardRef as ReactComponent };